import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { Switch, HTML, Tooltip, Link } from 'components';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const ServiceTile = ({
  first,
  onChange,
  service,
  suppressedMessage = 'Доступно автоматически',
  servicePending,
}) => {
  const onSwitchChange = useCallback(() => {
    onChange(service.soc);
  }, [service.soc]);

  return (
    <div className={cx('service', !first && 'withMargin')}>
      <div className={cx('serviceInfo')}>
        {service.url
          ? (
            <div className={cx('serviceText')}>
              <Link href={service.url}>
                <HTML>{service.name}</HTML>
              </Link>
            </div>
          )
          : (
            <HTML as="div" className={cx('serviceText')}>{service.name}</HTML>
          )}
        {service.suppressed && <HTML as="div" className={cx('serviceSuppressedMessage')}>{suppressedMessage}</HTML>}
        {(service.price || service.toolTip) && !service.suppressed && (
          <div className={cx('servicePrice')}>
            <HTML className={cx(service.isPromo && 'highlight')}>{service.price}</HTML>
            {!!service.toolTip && (
              <Tooltip>
                {service.toolTip}
              </Tooltip>
            )}
          </div>
        )}
        <div className={cx('serviceIcons')}>
          <img src={service.icon} alt="" className={cx('serviceIconImage')} />
        </div>
      </div>
      <Switch
        isLoading={servicePending === service.soc}
        disabled={service.readonly || !!servicePending}
        checked={service.connected || service.suppressed}
        onChange={onSwitchChange}
      />
    </div>
  );
};

ServiceTile.propTypes = {
  first: PropTypes.bool,
  onChange: PropTypes.func,

  suppressedMessage: PropTypes.string,
  servicePending: PropTypes.string,

  service: PropTypes.shape({
    name: PropTypes.string,
    soc: PropTypes.string,
    price: PropTypes.string,
    icon: PropTypes.string,
    toolTip: PropTypes.string,
    serviceType: PropTypes.string,
    url: PropTypes.string,

    readonly: PropTypes.bool,
    suppressed: PropTypes.bool,
    connected: PropTypes.bool,
    isPromo: PropTypes.bool,
  }),
};

export default ServiceTile;
